/* eslint-disable prettier/prettier */
import {
  Box,
  Button,
  ArrowRightIcon,
  UnstyledHtmlAnchor,
} from '@ttx/design-system';
import {ButtonStyleType} from '@ttx/design-system/src/button/types';
import React, {useMemo} from 'react';
import {CheckoutButtonType} from '../../hooks/use-checkout';

interface PurchaseCtaProps {
  buttonType: CheckoutButtonType;
  onPressSignUp?: () => void;
  onPressPurchase?: () => void;
  openseaUrl?: string;
  title?: string;
  type?: ButtonStyleType;
}

export const PurchaseCta: React.FC<PurchaseCtaProps> = ({
  buttonType,
  onPressSignUp,
  onPressPurchase,
  openseaUrl,
  title,
  type = 'primary',
}: PurchaseCtaProps) => {
  const buttonContent = useMemo(() => {
    switch (buttonType) {
      case CheckoutButtonType.CUSTOM:
        return (
          <Button
            type={type}
            hasBorder={type === 'secondary'}
            buttonStyle={{margin: '8px 6px 8px 6px'}}
            onPress={onPressPurchase}
            leftAccessory={<ArrowRightIcon color="surfaceDark" />}
          >
            {title}
          </Button>
        );
      case CheckoutButtonType.PURCHASE:
        return (
          <Button
            type={type}
            hasBorder={type === 'secondary'}
            buttonStyle={{margin: '8px 6px 8px 6px'}}
            onPress={onPressPurchase}
            leftAccessory={<ArrowRightIcon color="surfaceDark" />}
          >
            Purchase
          </Button>
        );
      case CheckoutButtonType.PURCHASE_DISABLE:
        return (
          <Button
            type={type}
            hasBorder={type === 'secondary'}
            buttonStyle={{margin: '8px 6px 8px 6px'}}
            leftAccessory={<ArrowRightIcon color="surfaceDark" />}
            disabled
          >
            Purchase
          </Button>
        );
      case CheckoutButtonType.VIEW_ON_POLYMESH_PORTAL:
        return (
          <Button
            type={type}
            hasBorder={type === 'secondary'}
            buttonStyle={{margin: '8px 6px 8px 6px'}}
            leftAccessory={<ArrowRightIcon color="surfaceDark" />}
            onPress={onPressPurchase}
          >
            View on Polymesh Portal
          </Button>
        );
      case CheckoutButtonType.MINT:
        return (
          <Button
            type={type}
            hasBorder={type === 'secondary'}
            buttonStyle={{margin: '8px 6px 8px 6px'}}
            onPress={onPressPurchase}
            leftAccessory={<ArrowRightIcon color="surfaceDark" />}
          >
            Mint
          </Button>
        );
      case CheckoutButtonType.COMING_SOON:
        return (
          <Button
            type={type}
            hasBorder={type === 'secondary'}
            buttonStyle={{margin: '8px 6px 8px 6px'}}
            disabled
          >
            Coming soon
          </Button>
        );
      case CheckoutButtonType.FREE:
        return (
          <Button
            type={type}
            hasBorder={type === 'secondary'}
            onPress={onPressPurchase}
            buttonStyle={{margin: '8px 6px 8px 6px'}}
            leftAccessory={<ArrowRightIcon color="surfaceDark" />}
          >
            Claim free NFT
          </Button>
        );
      case CheckoutButtonType.SOLD_OUT:
        return (
          <>
            {openseaUrl ? (
              <UnstyledHtmlAnchor
                href={openseaUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button
                  type={type}
                  hasBorder={type === 'secondary'}
                  buttonStyle={{margin: '8px 6px 8px 6px'}}
                  onPress={() => null}
                >
                  View on OpenSea
                </Button>
              </UnstyledHtmlAnchor>
            ) : null}
          </>
        );
      case CheckoutButtonType.SIGN_UP:
        return (
          <Button
            type={type}
            hasBorder={type === 'secondary'}
            onPress={onPressSignUp}
            buttonStyle={{margin: '8px 6px 8px 6px'}}
            leftAccessory={<ArrowRightIcon color="surfaceDark" />}
          >
            Sign up for updates
          </Button>
        );
      case CheckoutButtonType.LOADING:
        return (
          <Button
            type={type}
            hasBorder={type === 'secondary'}
            loading
            loaderColor="outlinesInvert"
            buttonStyle={{margin: '8px 6px 8px 6px'}}
            leftAccessory={<ArrowRightIcon color="surfaceDark" />}
          >
            loading
          </Button>
        );
      default:
        return null;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [buttonType, onPressPurchase, onPressSignUp, openseaUrl]);

  return (
    <Box borderTopColor="outlines" borderTopWidth="zero" borderTopStyle="solid">
      {buttonContent}
    </Box>
  );
};
